import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  boxSportWrapper: {
    display: 'none',
  },
  pageButtonWellWrapperOverride: {},
  pageHeader: { fontSize: '2xl' },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: ['2', null, null, '4'],
  },
  boxWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'transparent',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: '#0B3A5B',
    borderRadius: 'none',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
    pb: '2',
    pos: 'relative',
    sx: {
      '&&': {
        mb: '2',
      },
    },
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'md',
    gap: '1',
  },
  headingIcon: {
    color: 'alpha.600',
    sx: {},
  },
  propositionButton: {
    flex: '1',
    height: '38px',
    display: 'inline-flex',
  },
  buttonAllSports: {
    _active: {
      bg: 'gamma.400',
      borderColor: 'gamma.400',
      color: 'alpha.800',
      '&:after': {
        display: 'none',
      },
    },
  },
  buttonSport: {
    borderColor: 'gamma.400',
    bg: 'blackAlpha.600',
    color: 'white',
  },
};
